/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userBusinessDrawsParticipations.internal

import features.userBusinessDrawsParticipations.models.ParticipationsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class UserBusinessDrawsParticipationsServiceImpl : UserBusinessDrawsParticipationsService {

    private val userBusinessDrawsParticipationsRequest = UserBusinessDrawsParticipationsRequest()

    override suspend fun getUserBusinessDrawsParticipations(
        overrideHeaders : Map<String, String>?,
        businessId: String    ): Result<ParticipationsModel> {
        return userBusinessDrawsParticipationsRequest.getUserBusinessDrawsParticipations(
            overrideHeaders = overrideHeaders,
            businessId = businessId        ).toModel()
    }
}
